/**
 *
 * Asynchronously loads the component for ConfiguratorForm
 *
 */

import { lazyLoad } from 'utils/loadable';

export const ConfiguratorForm = lazyLoad(
  () => import('./index'),
  module => module.ConfiguratorForm,
);
